import AuthForm from "../../features/auth/AuthForm";
import SignUpImg from "../../assets/images/SignUpImg.png";

const PartnerRegistration = () => {

  return (
    <AuthForm
      type="register"
      title="Create Account"
      subtitle="Sign up with your mobile number to get started"
      image={SignUpImg}
      redirectOnSuccess="/sign-up/complete-profile"
      footerText="Already have an account?"
      footerLink="Login"
      footerPath="/login"
      userType="PARTNER"
    /> 
  );
};

export default PartnerRegistration;